import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux"; // Import Redux hooks
import { VerifyCertificateData } from "../../Actions/CourseA";
import { useNavigate } from "react-router-dom";

const VerifyCertificatePopup = ({setShowPopup, text }) => {
  const navigate = useNavigate(); // For navigation
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const dispatch = useDispatch();

  const { certificateLinkData } = useSelector(
    (Store) => Store.CourseReducer
  );

console.log("certificateLinkData in PaymentInstallmentsInvoice is:",certificateLinkData)


   // State for form inputs
   const [studentId, setStudentId] = useState("");
   const [emailId, setEmailId] = useState("");
   const [lastName, setLastName] = useState("");
   const [error, setError] = useState(""); // State for error message
   
  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowPopup(false);
  }

  // Handle form submission
  const handleVerify = async () => {
    if (!studentId && !emailId && !lastName) {
      setError("All fields are required");
      return;
    }

    // Validate email format before making request
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailId)) {
      setError("Invalid email format");
      return;
    }

    setError(""); // Clear previous errors

    dispatch(VerifyCertificateData(studentId, emailId, lastName))

    // dispatch(VerifyCertificateData(studentId, emailId, lastName))
    //   .then((response) => {
    //     console.log("response is:",response)
    //     if (certificateLinkData) {
    //       const qrUrl = window.location.origin; // Gets the base URL dynamically
    //       const qrData = `${qrUrl}/verifycertificate/${certificateLinkData?.certificateId}`;      
    //       navigate(qrData);
    //     } else {
    //       setError(response.payload?.message || "Verification failed.");
    //     }
    //   })
    //   .catch(() => {
    //     setError("Something went wrong. Please try again.");
    //   });
  };

  useEffect(() => {
    if(certificateLinkData){
      if(certificateLinkData?.certificateId){
        const qrUrl = window.location.origin; // Gets the base URL dynamically
        const qrData = `/verifycertificate/${certificateLinkData?.certificateId}`;      
        navigate(qrData);
      } else {
        setError(certificateLinkData.message || "Verification failed.");
      }
  }
}, [certificateLinkData]);

    return (
      <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[23px] bg-white px-[30px] py-[20px] shadow-lg">
          <div className="absolute top-2 right-2">
            <img
              className="absolute right-3 top-[6px] cursor-pointer"
              src={require("./Assets/Cross.svg").default}
              alt=""
              onClick={closePopup}
            />
          </div>
          <div className="flex flex-col gap-[10px]">
              <h2
                className=" text-center text-[22px]"
              >
                Certificate Verification
              </h2>
              <p className="text-center text-[16px] ">Please enter the student ID for certificate verification.</p>
              <div className="flex flex-col gap-[5px]">
                <p className="text-[16px] font-bold">Student ID</p>
                <input
                  type="text"
                  className="w-full rounded-md py-2 px-[10px] border border-gray-300 shadow-sm"
                  value={studentId}
                  onChange={(e) => setStudentId(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-[5px]">
                <p className="text-[16px] font-bold">Email ID</p>
                <input
                  type="email"
                  className="w-full rounded-md py-2 px-[10px] border border-gray-300 shadow-sm"
                  value={emailId}
                  onChange={(e) => setEmailId(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-[5px]">
                <p className="text-[16px] font-bold">Last Name</p>
                <input
                  type="text"
                  className="w-full rounded-md py-2 px-[10px] border border-gray-300 shadow-sm"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                /> 
              </div>
          </div>
          {error &&  <p className="text-[#FF0000] text-[18px]">{error} ⛔</p> }
          <div className="w-full flex justify-center items-center gap-[20px] mt-[20px]">
          <button
                className="w-[100px] h-[40px] rounded-[6px] bg-[#FFFFFF] text-[#A1A3EF] text-[18px] cursor-pointer"
                style={{border:"1px solid #A1A3EF"}}
                onClick={closePopup}>
               Back
            </button>
            <button
              className={`w-[100px] h-[40px] rounded ${
                  studentId && emailId && lastName
                    ? "bg-[#A1A3EF] text-white cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}     
                onClick={handleVerify}
                disabled={!studentId || !emailId || !lastName} // Disable if any field is empty
               >
               Verify
            </button>
          </div>
        </div>
      </div>
    );
  };

export default VerifyCertificatePopup;
